import React from 'react';
import { RefreshCw, X, Loader2 } from 'lucide-react';
import { useVersionCheck } from '../hooks/useVersionCheck';

export function UpdateBanner() {
  const updateAvailable = useVersionCheck();
  const [dismissed, setDismissed] = React.useState(false);
  const [waiting,   setWaiting]   = React.useState(false);

  if (!updateAvailable || dismissed) return null;

  const handleActualiser = async () => {
    setWaiting(true);
    // Attendre que le backend soit prêt avant de recharger
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    for (let i = 0; i < 30; i++) {           // max 90s (30 × 3s)
      try {
        const r = await fetch(`${backendUrl}/api/health`, { cache: 'no-store' });
        if (r.ok) { window.location.reload(); return; }
      } catch (_) {}
      await new Promise(res => setTimeout(res, 3000));
    }
    // Fallback : recharger quand même après 90s
    window.location.reload();
  };

  return (
    <>
      <style>{`
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(24px); }
          to   { opacity: 1; transform: translateX(0);    }
        }
      `}</style>
      <div
        data-testid="update-banner"
        style={{
          position: 'fixed', top: 16, right: 16, zIndex: 9999,
          background: 'white', border: '1px solid #DBEAFE', borderRadius: 12,
          boxShadow: '0 8px 32px rgba(29,78,216,0.12)',
          padding: '12px 14px 12px 16px',
          display: 'flex', alignItems: 'center', gap: 12,
          maxWidth: 340, animation: 'slideInRight 0.3s ease',
        }}
      >
        <div style={{ width: 32, height: 32, borderRadius: 8, background: '#EFF6FF', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {waiting
            ? <Loader2 size={15} style={{ color: '#1D4ED8', animation: 'spin 1s linear infinite' }} />
            : <RefreshCw size={15} style={{ color: '#1D4ED8' }} />
          }
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontSize: 13, fontWeight: 700, color: '#111827', margin: 0, lineHeight: 1.3 }}>
            Nouvelle version disponible
          </p>
          <p style={{ fontSize: 11, color: '#6B7280', margin: '2px 0 0', lineHeight: 1.4 }}>
            {waiting ? 'Attente du serveur…' : 'Cliquez pour bénéficier des dernières améliorations.'}
          </p>
        </div>

        <button
          onClick={handleActualiser}
          disabled={waiting}
          data-testid="update-banner-btn"
          style={{ padding: '6px 14px', borderRadius: 8, border: 'none', background: waiting ? '#93C5FD' : '#1D4ED8', color: 'white', fontSize: 12, fontWeight: 600, cursor: waiting ? 'default' : 'pointer', flexShrink: 0, whiteSpace: 'nowrap', transition: 'background 0.15s' }}
          onMouseEnter={e => { if (!waiting) e.currentTarget.style.background = '#1E40AF'; }}
          onMouseLeave={e => { if (!waiting) e.currentTarget.style.background = '#1D4ED8'; }}
        >
          {waiting ? '…' : 'Actualiser'}
        </button>

        {!waiting && (
          <button
            onClick={() => setDismissed(true)}
            data-testid="update-banner-close"
            title="Fermer"
            style={{ padding: 4, border: 'none', background: 'transparent', cursor: 'pointer', flexShrink: 0, borderRadius: 4, display: 'flex', alignItems: 'center' }}
          >
            <X size={13} style={{ color: '#9CA3AF' }} />
          </button>
        )}
      </div>
    </>
  );
}
